import errors from './errors';
import setup from './setup';
import activityMenu from './activity-menu';
import externalControl from './external-control';

export default [
  setup,
  errors,
  activityMenu,
  externalControl
];
